import React from "react";
import { Link } from "react-router-dom";
import { Clock } from "@phosphor-icons/react";

const BASE = "inline-flex items-center gap-1 border px-1 text-[9px] uppercase tracking-widest transition-colors duration-100";

/** "Mon 9 AM CST", "today 9:30 AM EST", "tomorrow 8 AM PST" in the buyer's own time zone. */
export function opensLabel(iso, tz) {
  const d = new Date(iso);
  const fmt = (opts, at = d) => new Intl.DateTimeFormat("en-US", { timeZone: tz, ...opts }).format(at);
  const dayKey = (at) => fmt({ year: "numeric", month: "2-digit", day: "2-digit" }, at);
  const day = dayKey(d) === dayKey(new Date()) ? "today"
    : dayKey(d) === dayKey(new Date(Date.now() + 86400000)) ? "tomorrow" : fmt({ weekday: "short" });
  const time = fmt({ hour: "numeric", minute: fmt({ minute: "numeric" }) === "0" ? undefined : "2-digit" });
  const zone = new Intl.DateTimeFormat("en-US", { timeZone: tz, timeZoneName: "short" })
    .formatToParts(d).find((p) => p.type === "timeZoneName")?.value || "";
  return `${day} ${time} ${zone}`.trim();
}

// Clients list: is this buyer taking leads right now? Opens the buyer's Lead hours.
export function HoursBadge({ orgId, hours }) {
  if (!hours) return null;
  const open = hours.open;
  const label = open ? `Open now${hours.always ? " · 24/7" : ""}` : `Closed until ${opensLabel(hours.opens_at, hours.timezone)}`;
  const tip = hours.always ? "Takes leads 24/7" : open ? "Inside their lead hours"
    : "Outside their lead hours: new leads wait for them or go to another open buyer, per their setting";
  return (
    <Link to={`/clients/${orgId}/manage`} title={`${tip}. Click to change their lead hours.`} data-testid={`org-hours-${orgId}`}
          data-open={open ? "true" : "false"}
          className={`${BASE} ${open ? "border-emerald-700 bg-emerald-50 text-emerald-900 hover:bg-emerald-700" : "border-amber-700 bg-amber-100 text-amber-900 hover:bg-amber-700"} hover:text-white`}>
      <Clock size={10} weight="bold" /> {label}
    </Link>
  );
}
